import type { ProgramDetails, ProgramFile } from '../../interface/Program';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const getProgramFiles = async (id: ProgramDetails['id']) => {
  try {
    const { data } = await api.get<{ data: ProgramFile[] }>(
      apiConfig.routes.entertainment.program.files(id)
    );

    return data.data;
  } catch {
    const { data } = await api.get<{ data: ProgramFile[] }>(
      apiConfig.routes.entertainment.program.publicFiles(id)
    );

    return data.data;
  }
};

export const useGetProgramFiles = (id: ProgramDetails['id']) =>
  useQuery({
    queryKey: ['program', id, 'files'],
    queryFn: () => getProgramFiles(id),
    enabled: !!id,
  });
